import { useEffect, useState } from "react";
import { Trash2, Download, Inbox } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function Submissions() {
  const [subs, setSubs] = useState([]);
  const [filter, setFilter] = useState("all");

  const load = () => api.get("/admin/submissions").then((r) => setSubs(r.data));
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm("মুছে ফেলবেন?")) return;
    await api.delete(`/admin/submissions/${id}`);
    load();
  };

  const exportCsv = () => {
    const rows = subs.filter((s) => filter === "all" || s.type === filter);
    if (!rows.length) { toast.error("কোনো ডেটা নেই"); return; }
    const keys = ["type", "name", "phone", "email", "course", "message", "at"];
    const csv = [keys.join(",")].concat(
      rows.map((r) => keys.map((k) => `"${(k === "type" || k === "at" ? r[k] : r.data?.[k]) ?? ""}"`).join(","))
    ).join("\n");
    const blob = new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8;" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = "submissions.csv";
    a.click();
  };

  const shown = subs.filter((s) => filter === "all" || s.type === filter);

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="font-heading text-2xl font-bold text-stone-800">ফর্ম জমা</h1>
          <p className="text-sm text-stone-500 mt-1">ভর্তি ও যোগাযোগ ফর্মের তথ্য</p>
        </div>
        <button onClick={exportCsv} className="inline-flex items-center gap-2 rounded-full border border-stone-200 px-4 py-2 text-sm text-stone-600 hover:bg-stone-50">
          <Download className="h-4 w-4" /> CSV ডাউনলোড
        </button>
      </div>

      <div className="flex gap-2 mb-4">
        {[["all", "সব"], ["admission", "ভর্তি"], ["contact", "যোগাযোগ"]].map(([k, l]) => (
          <button key={k} onClick={() => setFilter(k)} className={`rounded-full px-4 py-1.5 text-sm ${filter === k ? "bg-[var(--c-primary)] text-white" : "bg-white border border-stone-200 text-stone-600"}`}>{l}</button>
        ))}
      </div>

      {shown.length === 0 ? (
        <div className="bg-white rounded-2xl border border-stone-200 p-12 text-center text-stone-400">
          <Inbox className="h-10 w-10 mx-auto mb-3" /> কোনো জমা নেই।
        </div>
      ) : (
        <div className="bg-white rounded-2xl border border-stone-200 overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-stone-50 text-stone-500">
              <tr>
                <th className="text-right p-4 font-medium">ধরন</th>
                <th className="text-right p-4 font-medium">নাম</th>
                <th className="text-right p-4 font-medium">যোগাযোগ</th>
                <th className="text-right p-4 font-medium">বার্তা</th>
                <th className="p-4"></th>
              </tr>
            </thead>
            <tbody>
              {shown.map((s) => (
                <tr key={s.id} className="border-t border-stone-100">
                  <td className="p-4"><span className={`rounded-full px-2.5 py-1 text-xs ${s.type === "admission" ? "bg-[var(--c-secondary)]/10 text-[var(--c-secondary)]" : "bg-stone-100 text-stone-600"}`}>{s.type === "admission" ? "ভর্তি" : "যোগাযোগ"}</span></td>
                  <td className="p-4 text-stone-700">{s.data?.name || "—"}{s.data?.course && <div className="text-xs text-stone-400">{s.data.course}</div>}</td>
                  <td className="p-4 text-stone-600">{s.data?.phone || s.data?.email || "—"}</td>
                  <td className="p-4 text-stone-500 max-w-xs truncate">{s.data?.message || "—"}</td>
                  <td className="p-4"><button onClick={() => remove(s.id)} className="text-red-400 hover:text-red-600"><Trash2 className="h-4 w-4" /></button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
